import { Modal, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import WarningIcon from "@/assets/warning.svg?react";
import { brandModalBtnProps, modalWarningTone } from "@/components/BrandButton";
import styles from "./security.module.scss";

export function ConfirmChangesModal({
  open,
  deleted,
  onCancel,
  onConfirm,
  confirmLoading,
}: {
  open: boolean;
  deleted: string[];
  onCancel: () => void;
  onConfirm: () => void;
  confirmLoading?: boolean;
}) {
  const { t } = useTranslation();
  const tone = deleted.length > 0 ? "danger" : "primary";

  return (
    <Modal
      open={open}
      centered
      width={520}
      title={
        <Space size={20} align="center">
          <WarningIcon
            className="size-7"
            style={{ color: modalWarningTone[tone] }}
          />
          <span>{t("security.confirmTitle")}</span>
        </Space>
      }
      okText={t("security.confirmOk")}
      cancelText={t("common.cancel")}
      {...brandModalBtnProps(tone)}
      confirmLoading={confirmLoading}
      onOk={onConfirm}
      onCancel={onCancel}
      destroyOnHidden
      styles={{
        body: {
          // 图标 28 + 间距 20，正文与标题左缘对齐
          paddingLeft: "48px",
        },
      }}
    >
      <Typography.Paragraph className="!mb-3">
        {t("security.confirmDeleted")}
      </Typography.Paragraph>
      <ul className={styles.deletedBox}>
        {deleted.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <Typography.Paragraph className="!mt-3 !mb-0 !text-[#FF383C]">
        {t("security.confirmHint")}
      </Typography.Paragraph>
    </Modal>
  );
}
